import React from "react";
import withStyles from '@material-ui/core/styles/withStyles';
import Tooltip from "@material-ui/core/Tooltip";
import OpenInNew from '@material-ui/icons/OpenInNew';
import Close from '@material-ui/icons/Close';
import Refresh from '@material-ui/icons/Refresh';
import Edit from '@material-ui/icons/Edit';
import Add from '@material-ui/icons/Add';
import KeyboardReturn from '@material-ui/icons/KeyboardReturn';
import Star from '@material-ui/icons/Star';

const NormalTooltip = withStyles({
    popper: {
        zIndex: "111111",
        top: '-10px !important',
        left: '30px !important'
    },
    tooltip: {
        color: '#000',
        borderRadius: '2px',
        background: '#fff',
        border: '1px #000 solid',
        left: '100px'
    }
})(Tooltip);

const MUIIconWithTooltip = (props) => {
    const uiIcon = props.icon
    let Icon = null;
    let title = '';
    let className = '';

    if (uiIcon === 'OpenInNew') {
        Icon = OpenInNew
        title = 'Pop-out'
        // className = 'popOut'
    } else if (uiIcon === 'Close') {
        Icon = Close
        title = 'Close'
        // className = 'closeIcon'
    } else if (uiIcon === 'Refresh') {
        Icon = Refresh
        title = 'Refresh'
    } else if (uiIcon === 'Edit') {
        Icon = Edit
        title = 'Edit'
    } else if (uiIcon === 'Add') {
        Icon = Add
        title = 'Add'
    } else if (uiIcon === 'KeyboardReturn') {
        Icon = KeyboardReturn
        title = 'Add'
    } else if (uiIcon === 'Star') {
        Icon = Star
        title = 'Star'
    }

    return (
        <NormalTooltip
            title={
                <h6 className={`tooltipMUI`}>
                    {props.title ? props.title : title}
                </h6>}
        >
            <Icon
                id={props.id}
                style={props.style ? props.style : {}}
                className={`${props.className ? props.className : ''} ${className} material-icons`}
            />
        </NormalTooltip>
    )
}

export default MUIIconWithTooltip;
